import { z } from 'zod';

/**
 * User model representing database user record
 */
export const userSchema = z.object({
  id: z.string(),
  email: z.string().email(),
  isAdmin: z.boolean(),
  developer: z.boolean(),
  aiDescribe: z.boolean(),
  aiPhotos: z.boolean(),
  lastLoginAt: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string()
});
export type User = z.infer<typeof userSchema>;

/**
 * OAuth identity schema
 */
export const oauthIdentitySchema = z.object({
  userId: z.string(),
  provider: z.enum(['google']),
  providerUserId: z.string(),
  email: z.string().email().nullable(),
  displayName: z.string().nullable(),
  avatarUrl: z.string().url().nullable(),
  createdAt: z.string(),
  updatedAt: z.string()
});
export type OAuthIdentity = z.infer<typeof oauthIdentitySchema>;
